import { WebSocketSendRequestDataMessage } from './web-socket-send-request-data-message';

/**
 * {
 *   "action": "DATA_REQUEST",
 *   "entityId": 420420,
 *   "payload": {
 *     "companyId": 170479,
 *     "locationId": 420420,
 *     "requestId": "asd123",
 *     "userId": "user-id-here",
 *     "dataType": "WebsocketDataRequestType_GetDisplay",
 *     "metadata": {
 *       "DisplayId": "display-id-here",
 *       "IgnoreLastSession": "false",
 *       "LastModified": "0",
 *       "Source": "Display"
 *     }
 *   }
 * }
 */
export class WebSocketRequestDisplay extends WebSocketSendRequestDataMessage {
  constructor(displayId: string, ignoreLastSession?: boolean, lastModified?: number) {
    super();
    const IgnoreLastSession =
      ignoreLastSession !== undefined && ignoreLastSession !== null ? ignoreLastSession.toString() : 'false';
    const LastModified = lastModified !== undefined && lastModified !== null ? lastModified.toString() : '0';
    this.payload.dataType = 'WebsocketDataRequestType_GetDisplay';
    // Note: metadata is { key: [string] } pairs, so we need to convert everything to strings
    this.payload.metadata.DisplayId = displayId;
    this.payload.metadata.IgnoreLastSession = IgnoreLastSession;
    this.payload.metadata.LastModified = LastModified;
  }

  /**
   * This works a little differently than the dashboard app. The location id is the entity id of the web socket
   * connection. The entity id is sourced from the display id on the server, and returned in the
   * "Connection Established" message of the web socket. Therefore, before this message goes out the door,
   * the web socket service will add the entity id as the location id to the message.
   *
   * Note: metadata is { key: [string] } pairs, so we need to convert everything to strings
   */
  addLocationIdToPayloadMetadata(locationId: number): void {
    this.payload.locationId = locationId;
    this.payload.metadata.locationId = locationId?.toString();
  }
}
